import { render, staticRenderFns } from "./ListaPreciosVentaDelete.vue?vue&type=template&id=66f8124d&"
import script from "./ListaPreciosVentaDelete.vue?vue&type=script&lang=js&"
export * from "./ListaPreciosVentaDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports